<template>
  <section v-if="project">
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="请输入项目编号" v-model="project.number"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="申报单位">
      <el-input size="small" :disabled="true" v-model="project.deptName"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="联系人">
          <el-input size="small" :disabled="true" v-model="project.leader.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话">
          <el-input size="small" :disabled="true" v-model="project.leader.mobile"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="16">
      <el-form-item label="项目名称">
        <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
      </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="批文号">
          <el-input size="small" v-model="form.lxpwh" placeholder="请输入批文号"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item class="underline-label" label="已线下通过该审批">
      <el-radio v-model="form.underLine" label="1">是</el-radio>
      <el-radio v-model="form.underLine" label="0">否</el-radio>
      <p class="tip" v-if="form.underLine=='1'" style="padding:0 10px;border:1px #d93c37 solid;">*已线下通过的审批须在附件中上传原始审批文件或三重一大会议纪要等相关证明文件，方便领导批阅。</p>
    </el-form-item>
    <el-form-item label="批复的工程建设规模、建设标准、建设内容">
      <el-input type="textarea" placeholder="批复的工程建设规模、建设标准、建设内容" :autosize="{ minRows: 3, maxRows: 6}" size="small"
        v-model="form.gcjsgm"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="建设性质">
          <el-select size="small" v-model="form.jsxz" placeholder="请选择建设性质">
            <el-option v-for="item in jsxzArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="工程专业">
          <el-select size="small" multiple v-model="gczyValue" placeholder="请选择工程专业">
            <el-option v-for="item in gczyArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </div>


    <div class="tip" style="margin:20px 0 0 20px">* 工程经济及单位信息</div>
    <div class="clear" v-if="project.type!=4">

      <el-col :span="5">
        <label class="form-item-label">批复的概算投资(元)</label>
      </el-col>
      <el-col :span="7">
        <el-form-item label="总投资" label-width="100px">
          <el-input size="small" placeholder="总投资" v-model="form.ztz"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="建安工程费" label-width="120px">
          <el-input size="small" placeholder="建安工程费" v-model="form.jagcf"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="招标控制价(元)">
          <el-input size="small" placeholder="招标控制价(元)" v-model="form.zbkzj"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="project.type!=4">
        <el-form-item label="甲供材料/设备(元)" label-width="150px">
          <el-input size="small" placeholder="甲供材料/设备(元)" v-model="form.jgcl"></el-input>
        </el-form-item>
      </el-col>
    </div>

    <div class="clear">
      <el-col :span="12">
        <el-form-item label="设计单位">
          <el-input size="small" v-model="form.sjdw" placeholder="请输入设计单位"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="招标控制价编制单位">
          <el-input size="small" v-model="form.bzdw" placeholder="请输入招标控制价编制单位"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <!-- <el-form-item label="工程定额" v-if="operationType!='show'">
        <el-col :span="10">
          <el-select style="width:100%;" size="small" v-model="form.gcde" placeholder="请选择工程定额">
            <el-option v-for="item in gcdeArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-input size="small" v-if="form.gcde=='其他'" v-model="gcde" placeholder="请输入工程定额"></el-input>
        </el-col>
      </el-form-item> -->
      <el-form-item label="工程定额">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" size="small" v-model="form.gcde"></el-input>
        <div style="color:#d93c37;line-height:1.5;padding:5px 0;">
          例：<span v-for="item in gcdeArr">{{ item }}</span>
        </div>
      </el-form-item>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="计价方式">
          <el-select size="small" v-model="form.jjfs" placeholder="请选择投标方式">
            <el-option v-for="item in jjfsArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="发包方式">
          <el-select size="small" v-model="form.tbfs" placeholder="请选择发包方式">
            <el-option v-for="item in tbfsArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-form-item label="价格信息">
        <el-input type="textarea" placeholder="请输入价格信息" :autosize="{ minRows: 4, maxRows: 8}" size="small" v-model="form.jgxx"></el-input>
      </el-form-item>
    </div>

  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData', 'teamArr', 'projectArr', 'operationType'],
    data() {
      return {
        form: {},
        gcde: "",
        gczyValue: [],
        jsxzArr: ["新建", "修建", "改建", "其他"],
        gczyArr: ["市政", "水利", "土建", "绿化", "安装", "其他"],
        tbfsArr: ["县平台", "集团小型平台", "自行发包", "其他"],
        gcdeArr: ["《浙江省市政工程预算定额》（2018版）", "《浙江省安装工程预算定额》（2018版）", "《浙江省建筑工程预算定额》（2018版）", "《浙江省水利水电建筑工程预算定额》（2018版）",
          "《浙江省水利水电安装工程预算定额》（2018版）"
        ],
        jjfsArr: ["全费用工程量清单", "其他"],
      }
    },
    mounted() {
      this.form = this.formByFather
      if (this.form.gczy) {
        this.gczyValue = this.form.gczy.split(",")
      }
    },
    methods: {
      getFromData() {
        this.form.gczy = this.gczyValue.join(",")
        if (this.form.gcde == "其他") {
          this.form.gcde = this.gcde
        }
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },
      "form.gczy"() {
        if (this.form.gczy) {
          this.gczyValue = this.form.gczy.split(",")
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createBudget.vue